import { log } from './log';

/** No idea what this actually does. 🤷🏻‍♂️ */
export function detachDeletedInstance()
{
    log('info', 'lifecycle::detachDeletedInstance');
}
